import { useEffect, useState } from 'react'

// Responsive breakpoint convention (Tailwind defaults — no custom config):
//   mobile  = base   (< 768px)   → md:
//   tablet  = md      (768–1023)  → md: … lg:
//   desktop = lg      (≥ 1024px)  → lg:
// Use Tailwind responsive utilities for layout; reach for this hook only when
// behaviour (not just styling) must differ by breakpoint.
export const BREAKPOINTS = { tablet: '(min-width: 768px)', desktop: '(min-width: 1024px)' } as const

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia(query).matches,
  )

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setMatches(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}
